import {useConnectionStore} from "~/stores/connection";
import type {Pricing} from "~/types/subscription.types";

export const addPlanToEnvironment = async (workspaceId: string, environmentId: string, planType: string, quantity: number, successUrl: string, cancelUrl: string, paymentMethod: string | null) => {
    return useConnectionStore().execute('subscription/add-plan-to-environment', {
        workspaceId, environmentId, planType, quantity, successUrl, cancelUrl, paymentMethod
    })
}

export const addPlanToEnvironmentInvoiceBased = async (workspaceId: string, environmentId: string, planType: string, quantity: number, currency: string, invoiceInformation: any) => {
    return useConnectionStore().execute('subscription/add-plan-to-environment-invoice-based', {
        workspaceId, environmentId, planType, quantity, currency, invoiceInformation
    })
}


export const removePlanFromEnvironment = async (workspaceId: string, environmentId: string, planType: string) => {
    return useConnectionStore().execute('subscription/remove-plan-from-environment', {
        workspaceId, environmentId, planType
    })
}

export const changePlanOfWorkspace = async (workspaceId: string, environmentId: string, planType: string, quantity: number) => {
    return useConnectionStore().execute('subscription/change-plan-of-environment', {
        workspaceId, environmentId, planType, quantity
    })
}

export const fetchPricing = async () => {
    return useConnectionStore().query<Pricing>('prices/multi-currency')
}